module.exports = __webpack_public_path__ + "static/media/panic.bde67db4.svg";